(() => {
  const ROOT = '[data-w1gk-gallery]';

  function pauseMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach((v) => {
      try {
        v.pause();
      } catch (_) {}
    });
    slide.querySelectorAll('iframe').forEach((iframe) => {
      const src = iframe.getAttribute('src');
      if (src) {
        iframe.setAttribute('src', src);
      }
    });
  }

  function activate(root, index) {
    const scope = root.querySelector('[data-w1gk-gallery-carousel]') || root;
    const slides = [...scope.querySelectorAll('[data-w1gk-gallery-slide]')];
    const thumbs = [...scope.querySelectorAll('[data-w1gk-gallery-thumb]')];
    if (!slides.length) return;

    const next = Math.max(0, Math.min(index, slides.length - 1));
    const current = slides.find((s) => s.classList.contains('is-active'));
    if (current && current !== slides[next]) pauseMedia(current);

    slides.forEach((slide, i) => {
      const on = i === next;
      slide.classList.toggle('is-active', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
    });

    thumbs.forEach((thumb, i) => {
      const on = i === next;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) {
        try {
          thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
        } catch (_) {}
      }
    });
  }

  function currentIndex(root) {
    const scope = root.querySelector('[data-w1gk-gallery-carousel]') || root;
    const current = scope.querySelector('[data-w1gk-gallery-slide].is-active');
    return Number(current?.dataset.index || 0);
  }

  function init(root) {
    if (root.dataset.w1gkGalleryReady === '1') return;
    if (!root.querySelector('[data-w1gk-gallery-slide]')) return;
    root.dataset.w1gkGalleryReady = '1';

    root.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-w1gk-gallery-thumb]');
      if (thumb && root.contains(thumb)) {
        activate(root, Number(thumb.dataset.index || 0));
        return;
      }
      const prev = e.target.closest('[data-w1gk-gallery-prev]');
      if (prev && root.contains(prev)) {
        activate(root, currentIndex(root) - 1);
        return;
      }
      const next = e.target.closest('[data-w1gk-gallery-next]');
      if (next && root.contains(next)) {
        activate(root, currentIndex(root) + 1);
      }
    });

    const main = root.querySelector('[data-w1gk-gallery-main]');
    if (!main) return;
    let startX = 0;
    let tracking = false;

    main.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches[0]) return;
        tracking = true;
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    main.addEventListener(
      'touchend',
      (e) => {
        if (!tracking || !e.changedTouches[0]) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        activate(root, dx < 0 ? currentIndex(root) + 1 : currentIndex(root) - 1);
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
